import { useQuery } from '@tanstack/react-query';

import getSubscription from '@/api/subscriptions/getSubscription.endpoint';
import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import authConstants from '@/v2/domains/Auth/constants/constants';

export default function useGetSubscriptionQuery() {
  const { userId, userType } = useCurrentUser();

  return useQuery({
    queryKey: [QUERY_KEYS.SUBSCRIPTION, userId],
    queryFn: () => getSubscription(),
    enabled: userType === authConstants.userType.teacher,
    meta: {
      error: {
        title: 'Error loading subscription',
        description: 'There was a problem loading your subscription',
      },
    },
  });
}
